import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';
import { ECurrency } from '../../shared/enum';

export const currency = 'currency';
export const primaryDrainageTrenchPrice = 'primaryDrainageTrenchPrice';
export const secondaryDrainageTrenchPrice = 'secondaryDrainageTrenchPrice';
export const primaryChimneyPrice = 'primaryChimneyPrice';
export const secondaryChimneyPrice = 'secondaryChimneyPrice';

export const primaryCollector = 'primaryCollector';
export const secondaryCollector = 'secondaryCollector';
export const primaryChimney = 'primaryChimney';
export const secondaryChimney = 'secondaryChimney';
export const total = 'total';

export interface IPrice {
    [currency]: ECurrency;

    [primaryDrainageTrenchPrice]: number;
    [secondaryDrainageTrenchPrice]: number;
    [primaryChimneyPrice]: number;
    [secondaryChimneyPrice]: number;

    [primaryCollector]: number;
    [secondaryCollector]: number;
    [primaryChimney]: number;
    [secondaryChimney]: number;
    [total]: number;
}

export type TPrice = keyof IPrice;

export const initialePrice = {
    [currency]: ECurrency.Euro,

    [primaryDrainageTrenchPrice]: 0,
    [secondaryDrainageTrenchPrice]: 0,
    [primaryChimneyPrice]: 0,
    [secondaryChimneyPrice]: 0,

    [primaryCollector]: 0,
    [secondaryCollector]: 0,
    [primaryChimney]: 0,
    [secondaryChimney]: 0,
    [total]: 0,
};


const initialState: IReduxState<IPrice> = {
    status: EReduxState.initialState,
    data: initialePrice
};

export const priceSlice = createSlice({
    name: 'price',
    initialState,
    reducers: {
        cleanPrice: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setPrice: (state, action: PayloadAction<IPrice>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanPrice, setPrice } = priceSlice.actions;

export const selectPrice = (state: RootState) => state.price;

export default priceSlice.reducer;
